import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicyPage from "@/site/pages/privacy";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPolicyPage,
});
